module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.61e9490c.svg";